import context from '../../context';
import canActOnLocation from '../canActOnLocation';
import { EVENT_STATUS, SHIFT_TYPE, SHIFT_REJECTED_STATUS } from '../../constants';

export function isShiftPendingAcceptance(shift) {
  if (!isPublishedShift(shift)) {
    return false;
  }

  return Boolean(canSeeAcceptanceStatus(shift) && !shift.acceptance);
}

export function isShiftRejected(shift) {
  if (!isPublishedShift(shift)) {
    return false;
  }

  return Boolean(canSeeAcceptanceStatus(shift) && shift.acceptance === SHIFT_REJECTED_STATUS);
}

function canSeeAcceptanceStatus(shift) {
  return shift.user && (shift.user.isMe || canActOnLocation(context.me, shift.location));
}

function isPublishedShift(shift) {
  return shift.type === SHIFT_TYPE && shift.status === EVENT_STATUS.PUBLISHED;
}
